import adminApi from '../../apis/adminApi';

export async function getCustomers(params) {
  const response = await adminApi.get('/api/admin/customers', { params });
  return response.data;
}

export async function getCustomer(id) {
  const response = await adminApi.get(`/api/admin/customers/${id}`);
  return response.data;
}

export async function editPhysicalCustomer(id, values) {
  const response = await adminApi.put(`/api/admin/customers/physical/${id}`, values);
  return response.data;
}

export async function editLegalCustomer(id, values) {
  const response = await adminApi.put(`/api/admin/customers/legal/${id}`, values);
  return response.data;
}

export async function deleteCustomer(id) {
  const response = await adminApi.delete(`/api/admin/customers/${id}`);
  return response.data;
}

export async function resetCustomerPassword(id) {
  const response = await adminApi.post(`/api/admin/customers/${id}/reset-password`);
  return response.data;
}

export async function getPhysicalCustomers(params) {
  const response = await adminApi.get('/api/admin/customers/physical', { params });
  return response.data;
}

export async function getLegalCustomers(params) {
  const response = await adminApi.get('/api/admin/customers/legal', { params });
  return response.data;
}
